<div class="tw-flex tw-items-center tw-relative tw-px-2 tw-py-4">
  <div class="tw-absolute tw-p-1 tw-rounded-full tw-bg-gray-100 tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-[15px] tw-right-[10px] tw-cursor-pointer" style="width: 35px; height: 35px" (click)="close()">
    <div class="tw-text-black tw-text-500 tw-font-bold">&#10005;</div>
  </div>
  <div class="tw-w-full tw-bg-white tw-rounded-lg tw-p-2 tw-flex tw-flex-col tw-pt-4">
    @if (data.type === SHEET_TYPE.SUCCESS) {
      <h2 class="tw-font-body tw-font-semibold tw-text-600 tw-mt-2" i18n="@@reportUploadedSuccessfully">Report Uploaded Successfully</h2>
      <p class="tw-my-2 tw-font-body tw-text-300 tw-text-gray-500" i18n="@@reportUploadedMessage">Thank you for uploading your report! We've successfully received it and created a support ticket. Our team will review your report and get back to you as soon as possible.</p>
    }
    @if (data.type === SHEET_TYPE.ERROR) {
      <h2 class="tw-font-body tw-font-semibold tw-text-600 tw-mt-2" i18n="@@uploadFailed">Invalid file type</h2>
      <p class="tw-my-2 tw-font-body tw-text-300 tw-text-gray-500" i18n="@@fileTypeError">Please upload your report as a PDF or an image.</p>
    }
    @if (data.type === SHEET_TYPE.NOT_REPORT) {
      <h2 class="tw-font-body tw-font-semibold tw-text-600 tw-mt-2" i18n="@@notAReport">Not a Report</h2>
      <p class="tw-my-2 tw-font-body tw-text-300 tw-text-gray-500" i18n="@@notAReportMessage">The document you uploaded does not appear to be a report. Please upload a valid medical report.</p>
    }
    <div class="tw-my-2 tw-w-full tw-bg-teal-600 tw-h-[48px] tw-flex tw-items-center tw-justify-center tw-rounded-3 tw-text-white tw-text-400 tw-font-semibold tw-cursor-pointer"
      (click)="close()">
      <span class="tw-font-body tw-tracking-normal" i18n="@@okay">okay</span>
    </div>
  </div>
</div>
